<template>
  <div class="settings__pages">
    <h1 class="mb-2">Settings</h1>
    <p class="description--text">
      Expanding new sales channels helps you sell to new customers online, on mobile apps, through social networks, and
      in person.
    </p>
    <v-row>
      <v-col v-for="(page, index) in pages" :key="index" cols="12" md="4" sm="12" xs="12">
        <v-card
          height="100%"
          rounded="lg"
          class="d-flex align-center pa-4"
          style="gap: 16px"
          @click="
            $router.push({
              name:
                page.router !== 'website.settings.payments' || utilities.checkPermisson(`payment_providers`, user)
                  ? page.router
                  : 'no-access',
            })
          "
        >
          <div>
            <v-img :width="48" style="object-fit: contain;" :src="page.icon" :alt="page.des" />
          </div>
          <div class="flex">
            <h3>{{ page.title }}</h3>
            <p class="mb-0">{{ page.des }}</p>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import utilities from '@/helpers/utilities';

export default {
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      utilities,
      pages: [
        {
          icon: require('@/assets/images/sale-channels/google.svg'),
          title: 'Google',
          des: `Reach shoppers and get discovered across Google`,
          router: 'website.settings.sale-channels.google',
        },
        {
          icon: require('@/assets/images/sale-channels/ggads.svg'),
          title: 'Google Ads',
          des: `Reach new customers and grow your business with Google Ads`,
          router: 'website.settings.sale-channels.ggads',
        },
        // {
        //   icon: require('@/assets/images/sale-channels/facebook.svg'),
        //   title: 'Facebook Data Assistant',
        //   des: 'View data in Facebook Ads more timely and accurately',
        //   router: 'website.settings.sale-channels.facebook',
        // },
        // {
        //   icon: require('@/assets/images/sale-channels/esty.png'),
        //   title: 'Esty',
        //   des: 'View data in Facebook Ads more timely and accurately',
        //   router: 'website.settings.checkout',
        // },
        {
          icon: require('@/assets/images/sale-channels/pinterest.png'),
          title: 'Pinterest',
          des: 'Track actions people take on your website via Pinterest.',
          router: 'website.settings.sale-channels.pinterest',
        },
        {
          icon: require('@/assets/images/sale-channels/tiktok.png'),
          title: 'Tiktok',
          des: 'Find new customers and optimize your ads campaigns.',
          router: 'website.settings.sale-channels.tiktok',
        },
        {
          icon: require('@/assets/images/sale-channels/bingads.png'),
          title: 'Bing Ads',
          des: 'Understand more about customer behavior and the traffic source.',
          router: 'website.settings.sale-channels.bingads',
        },
        {
          icon: require('@/assets/images/sale-channels/criteo.png'),
          title: 'Criteo',
          des: 'Measure and understand actions that people take on your website.',
          router: 'website.settings.sale-channels.criteo',
        },
        {
          icon: require('@/assets/images/sale-channels/klaviyo.webp'),
          title: 'Klaviyo',
          des: 'Klavyio intergration.',
          router: 'website.settings.sale-channels.klaviyo',
        },
        // {
        //   icon: require('@/assets/images/sale-channels/trustPilot.webp'),
        //   title: 'Trust Pilot',
        //   des: 'Trust Pilot Review.',
        //   router: 'website.settings.sale-channels.trustPilot',
        // },
        {
          icon: require('@/assets/images/sale-channels/svgexport-6.svg'),
          title: 'Axon Ads',
          des: 'Axon Ads',
          router: 'website.settings.sale-channels.axonads',
        },
        {
          icon: require('@/assets/images/sale-channels/ad-roll.svg'),
          title: 'AdRoll',
          des: 'AdRoll',
          router: 'website.settings.sale-channels.adroll',
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
.card__background {
  background-color: #efefef;
  &:hover {
    background-color: white;
  }
  transition: background 0.2s;
}
</style>
